<div *ngIf="showModal && jobdescpritionAndTitle?.length" role="dialog" aria-modal="true" id="modalDesc" class="modal-container baseColorPalette dothover">
    <div class="modal-content" #modalContent>
        <h1 class="modal-title title centered-title" id="modalTitle">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1025 1024" fill="currentColor" class="title-icon"><title id="jobDescIconTitle">Job Description Icon</title>
    <path d="M960.488 768h-448q-27 0-45.5-18.5t-18.5-45.5t18.5-45.5t45.5-18.5h448q27 0 45.5 18.5t18.5 45.5t-18.5 45.5t-45.5 18.5zm0-384h-448q-27 0-45.5-19t-18.5-45.5t18.5-45t45.5-18.5h448q27 0 45.5 18.5t18.5 45t-18.5 45.5t-45.5 19zm0-256h-448q-27 0-45.5-19t-18.5-45.5t18.5-45t45.5-18.5h448q27 0 45.5 18.5t18.5 45t-18.5 45.5t-45.5 19zm-640 896h-256q-27 0-45.5-18.5T.488 960V704q0-27 18.5-45.5t45.5-18.5h256q26 0 45 18.5t19 45.5v256q0 27-19 45.5t-45 18.5zm0-640h-256q-27 0-45.5-19t-18.5-45V64q0-27 18.5-45.5T64.488 0h256q26 0 45 18.5t19 45.5v256q0 26-19 45t-45 19zm192 512h448q27 0 45.5 18.5t18.5 45.5t-19 45.5t-45 18.5h-448q-27 0-45.5-18.5t-18.5-45.5t18.5-45.5t45.5-18.5z"/>
  </svg><span>{{ 'Lbl_Jobdescription' | translate }}</span></h1>

        <button class="close-btn UnderLineLink link" (click)="closeModal()" #modalStart aria-label="Close job description modal" tabindex="0">
            <i class="fa fa-times-circle" aria-hidden="true"></i>
        </button>
        <div>
            <div *ngFor="let item of jobdescpritionAndTitle; let i = index" class="accordion-item" #accordionItem>
                <div *ngIf="isSelectedJobsMode && showAllJobsUncheckedError" class="all-jobs-unchecked-error" role="alert">
                           {{ 'Error_SelectAtLeastOneJob' | translate }}
                </div>
                <div class="accordion-header" (click)="toggleAccordion(i)" (keydown.enter)="toggleAccordion(i)" (keydown.space)="toggleAccordion(i)" [attr.aria-expanded]="expandedJobIndex === i" [attr.aria-controls]="'accordion-body-' + i" [attr.id]="'accordion-header-' + i"
                    role="button" tabindex="0">
                    <input *ngIf="isSelectedJobsMode"
                           type="checkbox"
                           class="job-checkbox"
                           [id]="'job-check-' + i"
                           [checked]="checkedJobs[i]"
                           (change)="onCheckboxChange(i, $any($event.target).checked)"
                           (click)="$event.stopPropagation()"
                           (keydown)="onCheckboxKeydown($event, i)"
                           tabindex="0" />
                    <i class="fa fa-briefcase icon-left" aria-hidden="true"></i>
                    <span class="job-title">{{ item.JobTitle|stripHtml }}</span>
                    <i class="fa fa-chevron-down arrow" [class.expanded]="expandedJobIndex === i" aria-hidden="true"></i>
                </div>
                <div #accordionBody [hidden]="expandedJobIndex !== i" [attr.id]="'accordion-body-' + i" role="region" class="accordion-body" [attr.aria-labelledby]="'accordion-header-' + i">
                    <span class="sr-only">Job description: </span>
                    <div id="jobDesc-{{ i }}" [innerHTML]="item.JobDescription | safeEmbedHtml" class="job-description-content sanitizedText"></div>
                </div>

            </div>
        </div>
        <div *ngIf="isSelectedJobsMode" class="save-btn-container">
            <button type="button" class="btn btn-success primaryButton" (click)="onSave()">
              {{ 'Button_Save' | translate }}
           </button>

            <button type="button" class="btn btn-secondary rightIcons" (click)="closeModal()">
            {{ 'Button_Cancel' | translate }}
            </button>
       </div>
    </div>
</div>
